import { useTranslation } from "react-i18next";

import BustleWordMark from "../../assets/images/bustle/StackedLockUpCoolBlue@0.5.png";
import { useVenue } from "./VenueContext";

export const ThankYou = () => {
  const { t } = useTranslation();

  const venue = useVenue();
  return (
    <div className="max-w-screen-sm mx-auto flex items-stretch flex-col justify-end space-y-96 h-[90vh]">
      <div className="flex-1 flex flex-col text-center space-y-96 h-[80vh] justify-between">
        <div className="border-dashed border-black border-y text-5xl py-48 font-medium">
          {t("bustleThankyou.servingMoreGoodTimes")}
        </div>
        <div className="space-y-16">
          <div className="flex-none border-dashed border-black border-y text-2xl font-semibold py-32">
            {t("bustleThankyou.comeAgain")}{" "}
          </div>
          <div className="w-96  mx-auto pb-32">
            <a href="https://heybustle.com">
              <img src={BustleWordMark} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
